// extracted by mini-css-extract-plugin
export default {"button":"languageCurrencyButton_button__cFkWM","selected":"languageCurrencyButton_selected__XoSBI"};